import polling from "@/utils/polling";
import cookies from "js-cookie";
import notice from 'iview/src/components/notice';
import { awaitTo } from "datagent/src/utils/"

import contact from "@/utils/contact";
import ReleaseModel    from '@/models/ReleaseModel'

export const RELEASE_ADD_POLLING_TASK = 'release/addPollingTask';
export const RELEASE_RUN = 'release/run';
export const RELEASE_ADD_TASK = 'release/addTask'
export const RELEASE_UPDATE_TASK = 'release/updateTask'
export const RELEASE_REMOVE_TASK = 'release/removeTask'
export const RELEASE_TASKS = 'release/tasks'

window.polling = polling

// polling.onProcess(({logs})=>{
//   console.log(logs)
// })

const groups = {}
export function $notice(group, desc=[], opts={}){
  opts = {
    type: 'info',
    title: '发布提示',
    duration: 0,
    onClose(){
      if(group) groups[group] = false
    },
    ...opts,
    render: h => {
      return <div style="line-height: 1.5" domPropsInnerHTML={desc.join("<br />")}></div>;
    },
    // render: h=>{
    //   console.log(h('div', desc.join(";#;").split(";").map(i=>i=="#"?h('br'):h('span',[i]))))
    //   return h('div', desc.join(";#;").split(";").map(i=>i=="#"?h('br'):h('span',[i])))
    // },
  }
  if(!!group) opts.name = group
  if(groups[group]) notice.close(group)
  notice[opts.type](opts)
}

const runList = {
  publish: async function (task_id, params){
    const $model = new ReleaseModel({ contact })
    const res = await $model.status({ id:task_id })
    console.log(res)
    if(res.total != 200) return
    this.updateTask({id:task_id,msg:res.msg,disabled:true}) //更新提示信息，由于异步的情况，下面还需要自行替换msg变量
    // commit(RELEASE_UPDATE_TASK, {id:task_id,msg:res.msg,disabled:true})

    let group = this.group
    if(group){
      const tasks = Object
        .values(this.tasks)
        .filter(t=>t.group==group)

      $notice(group,tasks.filter(t=>!!t.msg).map(t=>t.msg), {
        onClose:()=>{
          groups[group] = false
          // tasks.forEach(({id})=>commit(RELEASE_REMOVE_TASK, id))
          tasks.forEach(({id})=>this.stopTask(id))
        }
      })
    }else{
      $notice(this.group, [{id:task_id, desc:res.msg }])
      // commit(RELEASE_REMOVE_TASK, task_id);
      this.stopTask(task_id)
    }
  },
  industryAudit: async function (task_id, params){
    let [err, res] = await awaitTo(contact.remote().get('audit/industryAudit/isFinish', {id:params.id}))
    console.log(err,res)
    if(!!err) res = err.response
    let msg = {
      title: '批量终审提示',
      desc: res.data.msg,
      duration: 0,
      type: err ? 'warning' :'info'
    }
    if(res.status >= 400){
      this.stopTask(task_id)
    }
    if (res.data.code === 200){
      notice[msg.type](msg)
      this.stopTask(task_id)
    }
  },
  carbonIndustryAudit: async function (task_id, params){
    let [err, res] = await awaitTo(contact.remote().get('audit/carbonIndustryAudit/isFinish', {id:params.id}))
    console.log(err,res)
    if(!!err) res = err.response
    let msg = {
      title: '批量终审提示',
      desc: res.data.msg,
      duration: 0,
      type: err ? 'warning' :'info'
    }
    if(res.status >= 400){
      this.stopTask(task_id)
    }
    if(res.data.code === 200){
      notice[msg.type](msg)
      this.stopTask(task_id)
    }
  },
  refreshCompany: async function(task_id, params={}){
    let [err, res] = await awaitTo(contact.remote().get('company', params))
    if(!!err){
      return this.stopTask(task_id)
    }
    this.commit('setCompany', res.data.data.map(item => ({ id: item.stockCode, title:item.stockCode+" "+item.abbreviation, ...item })))
  },
  refreshListedCompany: async function(task_id, params={}){
    let [err, res] = await awaitTo(contact.remote().get('listedCompany/list', params))
    if(!!err){
      return this.stopTask(task_id)
    }
    this.commit('setListedCompany', res.data.data.map(item => ({ id: item.stockCode, title:item.stockCode+" "+item.abbreviation, ...item })))
  },
  refreshCarbonCompany: async function(task_id, params={}){
    let [err, res] = await awaitTo(contact.remote().get('carbonCompany', params))
    if(!!err){
      return this.stopTask(task_id)
    }
    this.commit('setCarbonCompany', res.data.data.map(item => ({ id: item.stockCode, title:item.stockCode+" "+item.abbreviation, ...item })))
  },
}

export default {
    state: {
      tasks: {}
    },
    mutations: {
      [RELEASE_ADD_TASK](state, {id,type,group,params, duration}){
        state.tasks[id]={ id,type,group,params,msg:'', duration, disabled:false }
      },
      [RELEASE_UPDATE_TASK](state, {id, msg, disabled}){
        const task = state.tasks[id]
        if(!task) return console.warn(`没有找到id为${id}的任务!`)
        if(!!msg) task.msg = msg
        if(typeof disabled != undefined){
          task.disabled = disabled
          polling.pause(id, disabled)
        }
      },
      [RELEASE_REMOVE_TASK](state, id){
        delete state.tasks[id]
      }
    },
    actions: {
        [RELEASE_ADD_POLLING_TASK]({state,commit}, task={}){
          const {id,type="publish",group,params={},duration=10000} = task
          commit(RELEASE_ADD_TASK, {id,type,group, params, duration})

          if(!!group) groups[group]=true
          const stopTask = task_id=>{
            polling.pause(task_id, true)
            commit(RELEASE_REMOVE_TASK, task_id)
          }
          const updateTask = task=>{
            commit(RELEASE_UPDATE_TASK, task)
          }
          polling.add(
            id,
            runList[type],
            {
              scope: { stopTask, updateTask, commit, group, tasks:state.tasks },
              args: [ params ]
            },
            duration
          )
        },
        [RELEASE_RUN]({state,commit}){
          // Object.keys(state.tasks).filter(id=>!!state.tasks[id].disabled).forEach(id=>commit(RELEASE_REMOVE_TASK, id))
          polling.run()
        }
    },
    getters: {
      [RELEASE_TASKS](state){
          return state.tasks;
      }
    }
}
